import { render, staticRenderFns } from "./MyAccountIcon.vue?vue&type=template&id=329662cb&scoped=true"
import script from "./MyAccountIcon.vue?vue&type=script&lang=ts"
export * from "./MyAccountIcon.vue?vue&type=script&lang=ts"
import style0 from "./MyAccountIcon.vue?vue&type=style&index=0&id=329662cb&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "329662cb",
  null
  
)

export default component.exports